import { Box } from 'components/elements'
import { styled } from 'styles'
import SidebarMenu from './SidebarMenu'
import { HamburderProps } from 'components/icons/hamburger/hamburger'
import { useEffect } from 'react'

const MD_BREAKPOINT = 991
const Sidebar = ({ toggleSidebar, sidebarToggle }: HamburderProps) => {
  useEffect(() => {
    const isMobileView = window.innerWidth < MD_BREAKPOINT
    if (toggleSidebar && isMobileView) {
      document.body.classList.add('bodyoverflow')
    } else {
      document.body.classList.remove('bodyoverflow')
    }
    // Cleanup on unmount
    return () => {
      document.body.classList.remove('bodyoverflow')
    }
  }, [toggleSidebar])
  return (
    <Box
      css={BackdropFilterCSS}
      className={`${toggleSidebar ? 'show--backdrop' : ''}`}
      onClick={event => {
        const clickedElement = event.target as HTMLElement
        const isSettingElement = clickedElement.classList.contains('is--setting')
        const isSettingElementChild = clickedElement.closest('.is--setting')
        if (!isSettingElement && !isSettingElementChild) {
          sidebarToggle?.()
        }
      }}
    >
      <SidebarWrapper className={`${toggleSidebar ? 'show--sidebar' : ''}`}>
        <Box css={{ px: 20, pt: 54, pb: 30, cursor: 'pointer' }}>
          <img width="190" src="/images/dlt-alert-logo.png" alt="logo" style={{ width: '100%', height: 'auto' }} />
        </Box>
        <SidebarMenu />
      </SidebarWrapper>
    </Box>
  )
}

const BackdropFilterCSS = {
  'position': 'fixed',
  'width': '100%',
  'height': '100vh',
  'background': '$white1A',
  'backdropFilter': 'blur(3px)',
  'opacity': 0,
  'pointerEvents': 'none',
  'transition': 'opacity .25s ease-in-out',
  'zIndex': 50,

  '&.show--backdrop': {
    pointerEvents: 'all',
    opacity: 1,
  },
  '@md': {
    pointerEvents: 'all',
    opacity: 1,
    width: 0,
  },
}

const SidebarWrapper = styled('div', {
  'display': 'flex',
  'flexDirection': 'column',
  'minWidth': '$space$sidebarWidth',
  'width': '$space$sidebarWidth',
  'color': '$trueWhite70',
  'height': '100dvh',
  'maxHeight': '100dvh',

  'bgImage': '$offcanvasGradient',
  'position': 'fixed',
  'left': 0,
  'top': 0,
  'transform': 'translateX(-100%)',
  'transition': 'transform .25s ease-in-out',

  '&.show--sidebar': {
    transform: 'translateX(0)',
  },
  '@md': {
    transform: 'translateX(0)',
  },
})

export default Sidebar
